import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { ICustomer } from '../../../../../../../app/entities/Customer'
import { ICustomerVehicle } from '../../../../../../../app/entities/CustomerVehicle'
import { IInstallationPoint } from '../../../../../../../app/entities/InstallationPoint'
import {
  isTenDigitPhoneNumber,
  isValidEmail,
} from '../../../../../global/helper-functions/formValidation'
import ContactForm from './contact/ContactForm'
import InstallationAddressForm from './installation-address/InstallationAddressForm'
import styles from './styles.module.css'
import VehicleInformationForm from './vehicle-information/VehicleInformationForm'
import { fetchData } from '../../../../../global/helper-functions/fetch'
import {
  updateCustomer,
  updateCustomerVehicle,
  updateInstallationPoint,
} from './api'
import { ILocation } from '../../../../../../../app/entities/Location'
export interface Address {
  countryCode?: string
  state: string
  zipCode: string
  city: string
  streetAddress1: string
}

function checkFormFields(formData: any) {
  let passes = true

  for (const key in formData) {
    const element = formData[key]
    if (
      (key !== 'additionalInfo' &&
        key !== 'aptOrSuite' &&
        key !== 'brandId' &&
        element === '') ||
      (key === 'email' && !isValidEmail(element)) ||
      (key === 'phoneNumber' && !isTenDigitPhoneNumber(element))
    ) {
      passes = false
    }
  }

  return passes
}

interface ICustomerInformationProps {
  customer: Partial<ICustomer>
  setCustomer: Function
  installationPoint: Partial<IInstallationPoint>
  setInstallationPoint: Function
  customerVehicle: Partial<ICustomerVehicle>
  setCustomerVehicle: Function
  chosenAddress?: google.maps.GeocoderResult | null | undefined
  setDisabled: Function
  ref: any
  mode: string
  location: ILocation | undefined
}

export const CustomerInformation = forwardRef(
  (
    {
      customer,
      setCustomer,
      installationPoint,
      setInstallationPoint,
      customerVehicle,
      setCustomerVehicle,
      chosenAddress,
      setDisabled,
      mode,
      location,
    }: ICustomerInformationProps,
    ref,
  ) => {
    const [formError, setFormError] = useState(false)

    useImperativeHandle(
      ref,
      () => ({
        useNextClick(callback: Function) {
          callback(true)
        },
        async useSaveClick() {
          try {
            await fetchData(updateInstallationPoint(installationPoint))
          } catch (error: any) {
            alert(
              'Something is wrong with the address. Please try a variation of the address instead.',
            )
            throw new Error(error)
          }
          await fetchData(updateCustomer(customer))
          await fetchData(updateCustomerVehicle(customerVehicle))
        },
      }),
      [customer, installationPoint, customerVehicle],
    )

    useEffect(() => {
      if (formError) {
        setFormError(false)
      }
      const isFormFilledOut = checkFormFields({
        ...customer,
        ...installationPoint,
        ...customerVehicle,
      })

      setDisabled(!isFormFilledOut)
    }, [customer, installationPoint, customerVehicle])

    return (
      <div className={styles.formContainer}>
        <ContactForm customer={customer} setCustomer={setCustomer} />
        <InstallationAddressForm
          installationPoint={installationPoint}
          setInstallationPoint={setInstallationPoint}
          customerVehicle={customerVehicle}
          setCustomerVehicle={setCustomerVehicle}
          initialChosenAddress={chosenAddress}
          location={location}
          mode={mode}
        />
        <VehicleInformationForm
          customerVehicle={customerVehicle}
          setCustomerVehicle={setCustomerVehicle}
        />
      </div>
    )
  },
)
